import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { cn } from '../../utils/cn';

/**
 * Back navigation for drill-in / detail screens. Defaults to history-back (returns to wherever
 * the user came from); pass `to` for a fixed parent route when history-back isn't reliable.
 */
export function BackButton({
  to,
  label,
  className,
}: {
  to?: string;
  label?: string;
  className?: string;
}) {
  const { t } = useTranslation();
  const navigate = useNavigate();
  return (
    <button
      type="button"
      onClick={() => (to ? navigate(to) : navigate(-1))}
      className={cn(
        'mb-4 inline-flex items-center gap-1.5 text-sm text-muted-foreground transition-colors hover:text-foreground',
        className
      )}
    >
      <ArrowLeft className="h-4 w-4" />
      {label ?? t('ui.back')}
    </button>
  );
}
